<script lang="ts">
  import {navigate} from 'svelte5-router'
  import {t} from '../i18n'
  import ModalTemplate from './ModalTemplate.svelte'
  import {modal} from '../stores/modal'
  import {toQueryParams} from '../utils/queryParams'

  let query = ''

  function search(e: Event) {
    e.preventDefault()
    navigate(`/explore?` + toQueryParams({tags: query}))
    modal.close()
  }
</script>

<ModalTemplate close={false}>
  <form class="modal-search-form" onsubmit={search}>
    <input required placeholder={t.topbar.find} bind:value={query} autofocus />

    <button class="find-btn" type="submit">
      <span class="icon-p-lupa"/>
    </button>
  </form>
</ModalTemplate>